// Banner shown above every authenticated page when the signed-in user
// hasn't filled in their name. Encourages new employees to set first /
// last name on their first sessions so notes, messages, signed tickets
// etc. don't show their raw email everywhere. Disappears the moment
// firstName OR lastName is non-empty in their profile doc.
export default function ProfilePromptBanner({ profile, onOpenProfile }) {
  const hasName =
    (profile?.firstName || "").trim() || (profile?.lastName || "").trim();
  if (hasName) return null;

  return (
    <div
      style={{
        background: "#fff3cd",
        color: "#5a4500",
        border: "1px solid #f1d775",
        borderRadius: "8px",
        padding: "10px 14px",
        margin: "0 0 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        flexWrap: "wrap",
      }}
    >
      <div style={{ fontSize: "13px" }}>
        <strong>Finish setting up your profile.</strong> Your name shows on
        notes, signed tickets, and the header — until you set it, others see
        your email address.
      </div>
      <button
        type="button"
        onClick={onOpenProfile}
        style={{
          background: "#1a5fb4",
          color: "white",
          border: "none",
          borderRadius: "6px",
          padding: "8px 14px",
          fontSize: "13px",
          fontWeight: 600,
          cursor: "pointer",
        }}
      >
        Set up your profile
      </button>
    </div>
  );
}
